/**
 * @fileoverview
 * Helper functions for storing and retrieving data from browser history state
 */
/**
 * Replace the current history state with the provided data
 * @param data - Object to replace history state with
 */
export const removeFromHistoryState = (key) => {
    if (typeof window === 'undefined' || !window.history) {
        return;
    }
    const currentState = window.history.state || {};
    const { [key]: _, ...newState } = currentState;
    window.history.replaceState(newState, '');
};
/**
 * Helper function to store data in browser history state
 * @param data - Object to store in history state
 * @param url - Optional URL to replace (defaults to current location)
 */
export const storeInHistoryState = (data) => {
    if (typeof window === 'undefined' || !window.history) {
        return;
    }
    const currentState = window.history.state || {};
    const newState = {
        ...currentState,
        ...data,
    };
    window.history.replaceState(newState, '');
};
/**
 * Helper function to retrieve data from browser history state
 * @param key - Key to retrieve from history state
 * @returns The value associated with the key, or undefined if not found
 */
export const getFromHistoryState = (key) => {
    if (typeof window === 'undefined' ||
        !window.history ||
        !window.history.state) {
        return undefined;
    }
    return window.history.state[key];
};
/**
 * Helper function to retrieve data from a specific URL's history state
 * This is useful when you have a URL and want to check if it has associated history state
 * @param url - The URL to check for history state
 * @param key - Key to retrieve from history state
 * @returns The value associated with the key, or undefined if not found
 */
export const getFromUrlHistoryState = (url, key) => {
    // Note: This function assumes the URL matches the current location
    // since we can only access the current history state
    if (url === location.href) {
        return getFromHistoryState(key);
    }
    return undefined;
};
